// dev Base URL
const BASE_URL = "https://devapps.intelligra.io";

// dev Base URL - gateway
const BASE_URL_DEV_GATEWAY = "https://devapps.intelligra.io:5517";

// prod base urls
const BASE_URL_PROD_PORT = "https://prodapps.intelligra.io";

// prod base urls  - gateway
const BASE_URL_PROD_GATEWAY = "https://prodapps.intelligra.io:5517";
const BASE_URL_PROD_GATEWAY_Auth = "https://prodapps.intelligra.io:107";
const BASE_URL_PROD_Port_Auth = "http://prodapps.intelligra.io:5514";

// auth base urls - this is because "Adesoji" said auth service is a standalone service and shouldn't go through the gateway
const BASE_URL_AUTH_DEV  = "https://devapps.intelligra.io:5501"
const BASE_URL_AUTH_PROD  = "https://prodapps.intelligra.io:5500"

// const currentEnv = "devPort";
const currentEnv = "prodPort";
// const currentEnv = "devGateway";
// const currentEnv = "prodGateway";

// Access Endpoints Base URL:
const BASE_URL_ACCESS_DEV = "https://devapps.intelligra.io:5523";
const BASE_URL_ACCESS_PROD = "https://prodapps.intelligra.io:5523";
// const BASE_URL_ACCESS = "http://devapps.intelligra.io:5522";
const BASE_URL_STAGING = "https://staging.intelligra.io";

// FBN Enpoint Base URL:
const BASE_URL_FBN_DEV = "https://devapps.intelligra.io:5523";
const BASE_URL_FBN_PROD = "https://prodapps.intelligra.io:5523";


export const api_key = "c72b56287cff420c1061e8357bd261b1";
export const api_Secret =
  "A30EE7E18F1AAEEA7FA7B409A73B7B7CC5B4EEAC12FEE1265C1B8FF3BB84F970";

// Determin the entry point - use "gateway" for production and "port" for dev environment
export const entryUrl =
   currentEnv === "devPort"
    ? "devPort"
    : currentEnv === "prodPort"
    ? "prodPort"
    : currentEnv === "devGateway"
    ? "devGateway"
    : currentEnv === "prodGateway"
    ? "prodGateway"
    : "gateway";
    
// Currency
export const currency = "NG";

// New allabord services obj
export const servicesObj = {
  authService: {
    gateway: `${BASE_URL}/authservice/api/v1`,
    // port: `${BASE_URL}:5501/api/v1`,
    devPort:`${BASE_URL_PROD_PORT}:5501/api/Authenticator`,
    prodPort: `${BASE_URL_PROD_PORT}:5501/api/Authenticator`,
    prodGateway: `${BASE_URL_PROD_GATEWAY_Auth}/authService/api/v1`,
    devGateway: `${BASE_URL_PROD_GATEWAY_Auth}/api/v1`,
  },
  coreService: {
    gateway: `${BASE_URL}/coreservice/api`,
    devPort:  `${BASE_URL}:5508/api`,
    prodPort: `${BASE_URL_PROD_PORT}:5508/api`,
    devGateway: `${BASE_URL_DEV_GATEWAY}/coreService/api`,
    prodGateway: `${BASE_URL_PROD_GATEWAY}/coreService/api`,
  },
  telcoService: {
    gateway: `${BASE_URL}/TelcoService/api`,
    devPort:  `${BASE_URL}:5503/api`,
    prodPort: `${BASE_URL_PROD_PORT}:5503/api`,
    devGateway: `${BASE_URL_DEV_GATEWAY}/telcoService/api`,
    prodGateway: `${BASE_URL_PROD_GATEWAY}/telcoService/api`,
  },
  aionService: {
    gateway: `${BASE_URL}/AionServ`,
    devPort:  `${BASE_URL}:5503/AionServ`,
    prodPort: `${BASE_URL_PROD_PORT}:5503/AionServ`,
    devGateway: `${BASE_URL_DEV_GATEWAY}/aionService/api/v2`,
    prodGateway: `${BASE_URL_PROD_GATEWAY}/aionService/api/v1`,
  },
  livenessCheck: {
    gateway: `${BASE_URL}/TelcoService/api/v1`,
    devPort: `${BASE_URL}:151`,
    prodPort: `${BASE_URL_PROD_PORT}:151`,
    devGateway: `${BASE_URL}:151`,
    prodGateway: `${BASE_URL_PROD_GATEWAY}:151`,
  },
  financierService: {
    gateway: `${BASE_URL}/FinancierService/api`,
    devPort:  `${BASE_URL}:5523/api`,
    prodPort: `${BASE_URL_PROD_PORT}:5523/api`,
    devGateway: `${BASE_URL_DEV_GATEWAY}/financierService/api`,
    prodGateway: `${BASE_URL_PROD_GATEWAY}/financierService/api`,
  },
  fileService: {
    gateway: `${BASE_URL}/fileservice/api`,
    devPort:  `${BASE_URL}:5521/api`,
    prodPort: `${BASE_URL_PROD_PORT}:5521/api`,
    devGateway: `${BASE_URL_DEV_GATEWAY}/fileService/api`,
    prodGateway: `${BASE_URL_PROD_GATEWAY}/fileService/api`,
  },
  dataService: {
    gateway: `${BASE_URL}/dataservice/api`,
    devPort:  `${BASE_URL}:5506/api`,
    prodPort: `${BASE_URL_PROD_PORT}:5506/api`,
    devGateway: `${BASE_URL_DEV_GATEWAY}/dataService/api`,
    prodGateway: `${BASE_URL_PROD_GATEWAY}/dataService/api`,
  },
  accessService:{
    devPort:  `${BASE_URL_ACCESS_DEV}/api`,
    prodPort: `${BASE_URL_ACCESS_PROD}/api`,
    devGateway: `${BASE_URL_ACCESS_DEV}/api`,
    prodGateway: `${BASE_URL_ACCESS_PROD}/api`,
  },
  FBNService:{
    devPort:`${BASE_URL_FBN_DEV}/api`,
    prodPort: `${BASE_URL_FBN_PROD}/api`,
    devGateway: `${BASE_URL_FBN_DEV}/api`,
    prodGateway: `${BASE_URL_FBN_PROD}/api`,
  },
};